import { render } from "./ChatbotCard.vue?vue&type=template&id=68447539&scoped=true&ts=true"
import script from "./ChatbotCard.vue?vue&type=script&lang=ts"
export * from "./ChatbotCard.vue?vue&type=script&lang=ts"

import "./ChatbotCard.vue?vue&type=style&index=0&id=68447539&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68447539"]])

export default __exports__